<template>
   <section class="flex">
      <header class="flex">
      <h3 >OUR VALUES</h3>
      <h1>Manyata</h1>
      <img src="../../assets/underline.png" alt="">
      </header>

<h1 class="empathy">
         Empathy . Curiosity . Authenticity . Creativity . Fun . Gamification . Spontaneity
      </h1>

  </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.empathy{
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: #4BA3C3;
        margin-top: 109px;
}
.flex{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    height: 487px;
    text-align: center;
    padding-top: 70px;
}
h3{
    color: #791E94;
    font-weight: 450;
}
h1{
     font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: #791E94;
}
</style>